<div class="bg-bleuCaliceo-300 bg-opacity-10">
  <section class="layout py-12 lg:py-24">
    <div class="lg:flex justify-between items-end pb-12">
      <div>
        <h2
          class="font-bold mb-4 text-4xl leading-tight text-bleuCaliceo-300">{{ 'pressArea' | translate }}</h2>
      </div>

      <div class="lg:flex gap-4">
        <a appHoverGradient
           class="flex items-center gap-3 my-6 lg:mt-0 lg:w-auto w-full justify-center px-6"
           href="/cdn/pressRelease/latest"
           target="_blank">
          <img alt="" class="h-4" height="24" ngSrc="assets/icons/white/newspaper.svg" width="24">
          {{ 'latestPressRelease' | translate }}
        </a>

        <a appHoverGradient
           class="flex items-center gap-3 my-6 lg:mt-0 lg:w-auto w-full justify-center px-6"
           href="/cdn/pressKit"
           target="_blank">
          <img alt="" class="h-4" height="24" ngSrc="assets/icons/white/newspaper.svg" width="24">
          {{ 'pressKit' | translate }}
        </a>

        <button (click)="drawerService.open({
                  component: GalleryComponent,
                  inputs: { images: globalService.press().images, downloadable: true, password: globalService.press().password }}
                )"
                appHoverGradient
                class="flex items-center gap-3 my-6 lg:mt-0 lg:w-auto w-full justify-center px-6">

          <img alt="" class="h-4" height="24" ngSrc="assets/icons/white/phototheque.svg" width="24">
          {{ 'photoLibrary' | translate }}
        </button>
      </div>
    </div>

    <div class="grid md:grid-cols-2 gap-6">
      <div>
        <h3
          class="font-bold mb-4 text-2xl leading-tight text-bleuCaliceo-300 uppercase">{{ 'inThePress' | translate }}</h3>
        <ul>
          @for (inThePress of globalService.press().inThePress; track inThePress) {
            <li class="flex gap-4 items-center">
              <a class="text-gray-500 py-1 hover:text-bleuCaliceo-300 flex gap-3" target="_blank"
                 [href]="inThePress.url">• {{ inThePress.title }}

                <img alt="new tab" ngSrc="assets/icons/blue/newtab.svg" width="20" height="20">
              </a>
            </li>
          }
        </ul>
      </div>
      <div class="md:mt-0 mt-12">
        <h3
          class="font-bold mb-4 text-2xl leading-tight text-bleuCaliceo-300 uppercase">{{ 'pressReleases' | translate }}</h3>
        <ul>
          @for (pressRelease of globalService.press().pressReleases; track pressRelease) {
            <li class="flex gap-4 items-center">
              <a class="text-gray-500 py-1 hover:text-bleuCaliceo-300 flex gap-3" target="_blank"
                 [href]="pressRelease.pdf.media | cdn: 'document'">
                <span>{{ pressRelease.date }}</span>
                <span>{{ pressRelease.title }}</span>
                <img alt="download" ngSrc="assets/icons/blue/download.svg" width="16" height="16">

              </a>
            </li>
          }
        </ul>
      </div>
    </div>
    <app-press-contact id="form"/>

  </section>
</div>
